<template>
    <InputContainer
        :name="name"
        :input-id="id"
        :label="label"
        :help-text="helpText"
        :errors="errors"
        :class="containerClass"
    >
        <Dropdown
            :id="id"
            v-model="value"
            :aria-invalid="isErrored ? 'true' : 'false'"
            :aria-errormessage="isErrored ? 'input-error-' + name : ''"
            :name="name"
            :choices="choices"
            :disabled="submitting || choices.length === 1"
            :is-errored="isErrored"
            placeholder=""
            class="floating-label-white"
            :dropdown-config="dropdownConfig"
            :use-native-menu="useNativeMenu"
            v-bind="$attrs"
            :data-cy="'input-' + name"
        >
            <template #singlelabel="slotProps">
                <slot name="singlelabel" :value="slotProps.value" />
            </template>

            <template #option="slotProps">
                <slot name="option" :option="slotProps.option" />
            </template>
        </Dropdown>
    </InputContainer>
</template>

<script setup lang="ts">
import InputContainer from './components/InputContainer.vue';
import type { DefaultProps } from '~/composables/useInput';
import { defaultEmits, defaultPropsDefaults } from '~/composables/useInput';
import { DropdownChoices } from '~/types/miscellaneous';

defineOptions({
    inheritAttrs: false,
});

const emit = defineEmits([...defaultEmits]);

interface Props extends DefaultProps {
    choices: DropdownChoices;
    placeholder?: string;
    useNativeMenu?: boolean;
    dropdownConfig?: { [key: string]: any };
}

const props = withDefaults(defineProps<Props>(), {
    ...defaultPropsDefaults,
    placeholder: 'Select...',
    useNativeMenu: false,
    dropdownConfig: () => ({}),
});

const { id, value, errors, isErrored } = useInput(props, emit);
</script>
